import type { LayerUnionWithAll } from "@/layers";
import { setLayersProps } from "@/reducer/MapsState";
import type { MapId } from "@/types/type-utils";
import { t } from "@lingui/core/macro";
import type {
  AlertLayer,
  AviationLayer,
  BackgroundMapLayer,
  CustomGeoJSONLayerOutput,
  DrawingLayer,
  EarthquakeLayer,
  NwaLayer,
  ThunderstormLayer,
  TropicalCycloneLayer,
} from "@mm/metx-workbench.meteomatics.com";
import { useDispatch } from "react-redux";
import { FormField } from "../../form-field";

export function InitTimeField(props: {
  layer: Exclude<
    LayerUnionWithAll,
    | AlertLayer
    | BackgroundMapLayer
    | AviationLayer
    | TropicalCycloneLayer
    | CustomGeoJSONLayerOutput
    | DrawingLayer
    | NwaLayer
    | EarthquakeLayer
    | ThunderstormLayer
  >;
  mapId: MapId;
}) {
  const dispatch = useDispatch();

  function changeShowInitTimeProps(newValue: boolean) {
    const layerProps = { layerId: props.layer.id, id: props.mapId.map, props: { show_init_time: newValue } };
    dispatch(setLayersProps(layerProps));
  }

  return (
    <FormField label={t`Show init date`}>
      <input
        type="checkbox"
        checked={!!props.layer.show_init_time}
        onChange={() => changeShowInitTimeProps(!props.layer.show_init_time)}
      />
    </FormField>
  );
}
